import { EHubEditMutations, } from './types';
const mutations = {
    [EHubEditMutations[0]](state, payload) {
        state.hubInfo = payload;
    },
    [EHubEditMutations[1]](state) {
        state.hubInfo = null;
    },
};
export default mutations;
